export default __webpack_public_path__ + "static/acq-category-2-2e3064dd390d9c90042254342a4ee37a.jpg";